import { gql } from "@apollo/client"
export const DOCK_FRAG = gql`
  fragment DockFrag on DockType {
    id
    name
    archive
    codename
    distributionCentre {
      id
      name
    }
    depot {
      id
      name
    }
  }
`
